import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { Button } from '../components/ui/button.tsx';
import { googleSignInUrl } from '../lib/api.ts';

// `redirect` is the URL the user was trying to access before being bounced
// here by _authenticated's beforeLoad. We thread it back through Google's
// state param via the API worker so the user lands where they intended.
//
// Validation: only same-origin relative paths are honored — full URLs (which
// could point at an attacker domain) get dropped. Zod's catch(undefined)
// neutralizes malformed input.
const loginSearchSchema = z.object({
  redirect: z
    .string()
    .refine(
      (s) => s.startsWith('/') && !s.startsWith('//'),
      'must be a same-origin path starting with /',
    )
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  component: LoginPage,
});

function LoginPage() {
  const { redirect } = Route.useSearch();

  return (
    <div className="bg-background text-foreground flex min-h-screen items-center justify-center p-8">
      <div className="max-w-md space-y-6 text-center">
        <h1 className="text-3xl font-semibold tracking-tight">Sign in</h1>
        <p className="text-muted-foreground">
          SEO Monitor — Three Stripes Digital internal tool. Sign-in is restricted to
          <span className="text-foreground"> @threestripesdigital.ca</span> and
          <span className="text-foreground"> @threestripesdigital.com</span> Google accounts.
        </p>
        {/* Full-page navigation (not XHR) so cookies set by Google during OAuth
            flow correctly. asChild lets Button render as an <a>. */}
        <Button asChild>
          <a href={googleSignInUrl(redirect)}>Sign in with Google</a>
        </Button>
      </div>
    </div>
  );
}
